import React from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react';
import { datetimeColumn, sharedColumns } from './SharedData';

const VoidedWinnersTable = ({ voidedWinners }) => {
    const columns = [
        ...sharedColumns.filter((x) => x.key !== 'entryRef'),
        datetimeColumn('Voided On')
    ];

    return (
        <DetailsList
            items={voidedWinners}
            columns={columns}
            selectionMode={SelectionMode.none}
            setKey="userId"
            layoutMode={DetailsListLayoutMode.justified}
        />
    );
};

export default VoidedWinnersTable;
